function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable sonarjs/no-nested-template-literals */
import React, { useMemo } from 'react';
import cs from 'classnames';
import { PropTypes } from 'prop-types';
import { playIcon as playIconSVG, pauseIcon as pauseIconSVG, volumeOffIcon as volumeOffIconSVG, volumeIcon as volumeIconSVG, exitFullscreenIcon as exitFullscreenIconSVG, enterFullscreenIcon as enterFullscreenIconSVG, seriesNavigationIcon as seriesNavigationIconSVG, captionsOnIcon as captionsOnIconSVG, captionsOffIcon as captionsOffIconSVG, closeIcon as closeIconSVG } from '@lululemon/ecom-pattern-library-icons';
import Image from '../image';
import Icon from '../icons';
require("./video.css");
var styles = {
  "videoPlayer": "videoPlayer-2N1mv",
  "video": "video-3TKQ9",
  "button": "button-3TbWX",
  "videoWrapper": "videoWrapper-3-XLA",
  "clickToPlay": "clickToPlay-1KnyL",
  "overlay": "overlay-13EMR",
  "asPoster": "asPoster-2Z9Wj",
  "startButtonImage": "startButtonImage-1Wjdm",
  "overlayEnded": "overlayEnded-2qptI",
  "play": "play-3kjUm",
  "loadingOverlay": "loadingOverlay-13Udq",
  "controls": "controls-3E74a",
  "topControls": "topControls-53JQI",
  "show": "show-3qNBp",
  "controlsList": "controlsList-1F3H8",
  "topControlsList": "topControlsList-1xWJZ",
  "control": "control-1z5bG",
  "playNextControl": "playNextControl-1XKIG",
  "playPreviousControl": "playPreviousControl-3YCPr",
  "playNext": "playNext-JUS_k",
  "playPrevious": "playPrevious-27vUe",
  "seriesNavigationIcon": "seriesNavigationIcon-2XOZ6",
  "rangeInput": "rangeInput-3DzXV",
  "rangeBar": "rangeBar-1F6Uv",
  "volumeControl": "volumeControl-1i31b",
  "volumeButton": "volumeButton-5YdRT",
  "volumeOffIcon": "volumeOffIcon-2menz",
  "volumeRange": "volumeRange-_QCD9",
  "volumeSlider": "volumeSlider-SEQu3",
  "progressControl": "progressControl-1nzAY",
  "progressRange": "progressRange-2vFsE",
  "timeTrackerControl": "timeTrackerControl-3ZMTA",
  "timeTrackerTime": "timeTrackerTime-35OQX",
  "duration": "duration-1ExVO",
  "fullscreenControl": "fullscreenControl-13Asf",
  "toggleFullscreen": "toggleFullscreen-1rSDV",
  "closeButton": "closeButton-19KUe",
  "toggleFullscreenIcon": "toggleFullscreenIcon-UQaV6",
  "closeButtonIcon": "closeButtonIcon-1B0iB",
  "playPauseControl": "playPauseControl-2FPUZ",
  "playPause": "playPause-26L2I",
  "playIcon": "playIcon-1k8q_",
  "pauseIcon": "pauseIcon-3e5yv",
  "playPauseButton": "playPauseButton-2GjX2",
  "center": "center-3NfzY",
  "captionsControl": "captionsControl-1zJoQ",
  "toggleCaptions": "toggleCaptions-25ubC",
  "toggleCaptionsIcon": "toggleCaptionsIcon-1JXnx"
};
var stringifyNumberForVideoTime = timeInSeconds => {
  var timeHours = Math.floor(timeInSeconds / 3600);
  var timeMinutes = Math.floor(timeInSeconds % 3600 / 60);
  var timeSeconds = Math.floor(timeInSeconds) % 60;
  return "".concat(timeHours > 0 ? "".concat(timeHours, ":") : '').concat(timeHours > 0 && timeMinutes <= 9 ? '0' : '').concat(timeMinutes, ":").concat(timeSeconds <= 9 ? '0' : '').concat(timeSeconds, "\n  ");
};
var playIcon = /*#__PURE__*/React.createElement(Icon, {
  content: playIconSVG,
  className: styles.playIcon,
  title: "Play Video"
});
var pauseIcon = /*#__PURE__*/React.createElement(Icon, {
  content: pauseIconSVG,
  className: styles.pauseIcon,
  title: "Pause Video"
});
var volumeOffIcon = /*#__PURE__*/React.createElement(Icon, {
  content: volumeOffIconSVG,
  className: styles.volumeOffIcon,
  title: "Unmute Video"
});
var volumeIcon = /*#__PURE__*/React.createElement(Icon, {
  content: volumeIconSVG,
  className: styles.volumeIcon,
  title: "Video Volume Up"
});
var exitFullscreenIcon = /*#__PURE__*/React.createElement(Icon, {
  content: exitFullscreenIconSVG,
  className: styles.toggleFullscreenIcon,
  title: "Exit Fullscreen"
});
var enterFullscreenIcon = /*#__PURE__*/React.createElement(Icon, {
  content: enterFullscreenIconSVG,
  className: styles.toggleFullscreenIcon,
  title: "Enter Fullscreen"
});
var seriesNavigationIcon = title => /*#__PURE__*/React.createElement(Icon, {
  content: seriesNavigationIconSVG,
  className: styles.seriesNavigationIcon,
  title: title
});
var captionsOnIcon = /*#__PURE__*/React.createElement(Icon, {
  content: captionsOnIconSVG,
  className: styles.toggleCaptionsIcon,
  title: "Hide Captions"
});
var captionsOffIcon = /*#__PURE__*/React.createElement(Icon, {
  content: captionsOffIconSVG,
  className: styles.toggleCaptionsIcon,
  title: "Show Captions"
});
var playButton = /*#__PURE__*/React.createElement("span", {
  className: styles.playPauseButton
}, playIcon);
var pauseButton = /*#__PURE__*/React.createElement("span", {
  className: styles.playPauseButton
}, pauseIcon);
var VideoPlayerControlOverlay = _ref => {
  var {
    controlLayout,
    currentTime,
    currentVolume,
    hasBeenPlayed,
    isEnded,
    isFullscreen,
    isMuted,
    isPartOfSeries,
    isPlaying,
    isShowingCaptions,
    launchFullscreenOnStart,
    nextInSeriesButtonRef,
    onButtonFocus,
    onButtonBlur,
    onCaptionsToggleClick,
    onFullscreenButtonClick,
    onMuteButtonClick,
    onOverlayClick,
    onPlayPauseButtonClick,
    onProgressKeyDown,
    onProgressRangeClick,
    onVolumeBarHoverChange,
    onVolumeInputChange,
    onVolumeRangeClick,
    overlayRef,
    playPauseButtonClassName,
    previousInSeriesButtonRef,
    showCaptionsToggle,
    showCloseFullscreen,
    showControls,
    showDuration,
    showFullscreenToggle,
    showVolumeBar,
    startButtonImageProps,
    startButtonRef,
    supportsAudio,
    videoDuration,
    videoUID,
    volumeBarRef,
    volumeControlRef
    // eslint-disable-next-line sonarjs/cognitive-complexity
  } = _ref;
  var playPreviousLi = /*#__PURE__*/React.createElement("li", {
    key: "play-previous-control-".concat(videoUID),
    className: cs(styles.control, styles.playPreviousControl)
  }, /*#__PURE__*/React.createElement("button", {
    className: cs(styles.button, styles.playPrevious),
    type: "button",
    ref: previousInSeriesButtonRef,
    onFocus: onButtonFocus,
    onBlur: onButtonBlur,
    onMouseDown: e => e.preventDefault() // prevent focus from being added with mouse
    ,
    title: "Play Previous Video"
  }, seriesNavigationIcon('Play Previous Video')));
  var playNextLi = /*#__PURE__*/React.createElement("li", {
    key: "play-next-control-".concat(videoUID),
    className: cs(styles.control, styles.playNextControl)
  }, /*#__PURE__*/React.createElement("button", {
    className: cs(styles.button, styles.playNext),
    type: "button",
    ref: nextInSeriesButtonRef,
    onFocus: onButtonFocus,
    onBlur: onButtonBlur,
    onMouseDown: e => e.preventDefault() // prevent focus from being added with mouse
    ,
    title: "Play Next Video"
  }, seriesNavigationIcon('Play Next Video')));
  var playPauseLi = /*#__PURE__*/React.createElement("li", {
    key: "play-pause-control-".concat(videoUID),
    className: cs(styles.control, styles.playPauseControl)
  }, /*#__PURE__*/React.createElement("button", {
    "data-testid": "play-pause-button",
    className: cs(styles.button, styles.playPause),
    type: "button",
    onClick: onPlayPauseButtonClick,
    onFocus: onButtonFocus,
    onBlur: onButtonBlur,
    onMouseDown: e => e.preventDefault() // prevent focus from being added with mouse
    // eslint-disable-next-line sonarjs/no-duplicate-string
    ,
    title: isPlaying ? 'Pause Video' : 'Play Video'
  }, isPlaying ? pauseIcon : playIcon));
  var volumeLi = /*#__PURE__*/React.createElement("li", {
    key: "volume-control-".concat(videoUID),
    ref: volumeControlRef,
    className: cs(styles.control, styles.volumeControl, showVolumeBar && styles.show),
    onMouseEnter: () => {
      onVolumeBarHoverChange(true);
    },
    onMouseLeave: () => {
      onVolumeBarHoverChange(false);
    }
  }, /*#__PURE__*/React.createElement("button", {
    "data-testid": "mute-unmute-button",
    className: cs(styles.button, styles.volumeButton),
    type: "button",
    onClick: onMuteButtonClick,
    onFocus: onButtonFocus,
    onBlur: onButtonBlur,
    onMouseDown: e => e.preventDefault() // prevent focus from being added with mouse
    ,
    title: isMuted ? 'Unmute Video' : 'Mute Video'
  }, isMuted ? volumeOffIcon : volumeIcon), controlLayout !== 'minimal' && /*#__PURE__*/React.createElement("div", {
    className: styles.volumeSlider
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "volumeSlider-".concat(videoUID),
    className: "lll-hidden-visually"
  }, "Volume"), /*#__PURE__*/React.createElement("input", {
    ref: volumeBarRef,
    className: cs(styles.volumeRange, styles.rangeInput),
    id: "volumeSlider-".concat(videoUID),
    min: "0",
    max: "1",
    step: "0.05",
    type: "range",
    onChange: e => onVolumeInputChange(e),
    onFocus: onButtonFocus,
    onBlur: onButtonBlur,
    onMouseDown: e => e.preventDefault() // prevent focus from being added with mouse
    ,
    onClick: e => {
      e.stopPropagation();
      onVolumeRangeClick(e.nativeEvent.offsetX / e.target.offsetWidth);
    },
    tabIndex: "0",
    "aria-valuemin": "0",
    "aria-valuemax": "1",
    "aria-valuenow": currentVolume
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.rangeBar,
    style: {
      /* stylelint-disable-next-line unit-disallowed-list */
      backgroundSize: "".concat(currentVolume * 100, "% 100%")
    }
  }), /*#__PURE__*/React.createElement("output", {
    htmlFor: "volumeSlider-".concat(videoUID),
    className: "lll-hidden-visually"
  }, "Volume ".concat(currentVolume * 100, "%"))));
  var progressPercentage = useMemo(() => videoDuration > 0 ? currentTime / videoDuration * 100 : 0, [currentTime, videoDuration]);
  var progressLi = /*#__PURE__*/React.createElement("li", {
    key: "progress-control-".concat(videoUID),
    className: cs(styles.control, styles.progressControl)
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "progressBar-".concat(videoUID),
    className: "lll-hidden-visually"
  }, "Progress"), /*#__PURE__*/React.createElement("input", {
    className: cs(styles.progressRange, styles.rangeInput),
    id: "progressBar-".concat(videoUID),
    type: "range",
    max: "100",
    value: progressPercentage,
    onFocus: onButtonFocus,
    onBlur: onButtonBlur,
    onChange: e => e.stopPropagation(e),
    onKeyDown: e => onProgressKeyDown(e),
    onMouseDown: e => e.preventDefault() // prevent focus from being added with mouse
    ,
    onClick: e => {
      e.stopPropagation();
      onProgressRangeClick(e.nativeEvent.offsetX / e.target.offsetWidth);
    },
    tabIndex: "0"
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.rangeBar,
    style: {
      /* stylelint-disable-next-line unit-disallowed-list */
      backgroundSize: "".concat(progressPercentage, "% 100%")
    }
  }), /*#__PURE__*/React.createElement("output", {
    htmlFor: "progressSlider-".concat(videoUID),
    className: "lll-hidden-visually"
  }, Math.floor(progressPercentage), "% played"));
  var prettyVideoDuration = useMemo(() => stringifyNumberForVideoTime(videoDuration), [videoDuration]);
  var timeTrackerDisplay = useMemo(() => "".concat(stringifyNumberForVideoTime(currentTime), "/ ").concat(prettyVideoDuration), [prettyVideoDuration, currentTime]);
  var timeTrackerLi = /*#__PURE__*/React.createElement("li", {
    "data-testid": "duration",
    key: "time-tracker-".concat(videoUID),
    className: cs(styles.control, styles.timeTrackerControl)
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.timeTrackerTime
  }, /*#__PURE__*/React.createElement("span", {
    className: "lll-hidden-visually"
  }, "Time"), timeTrackerDisplay));
  var fullscreenLi = /*#__PURE__*/React.createElement("li", {
    key: "fullscreen-control-".concat(videoUID),
    className: cs(styles.control, styles.fullscreenControl)
  }, /*#__PURE__*/React.createElement("button", {
    className: cs(styles.button, styles.toggleFullscreen),
    type: "button",
    onClick: onFullscreenButtonClick,
    onFocus: onButtonFocus,
    onBlur: onButtonBlur,
    onMouseDown: e => e.preventDefault() // prevent focus from being added with mouse
    ,
    title: isFullscreen ? 'Exit Fullscreen' : 'Enter Fullscreen'
  }, isFullscreen ? exitFullscreenIcon : enterFullscreenIcon));
  var closeButton = /*#__PURE__*/React.createElement("button", {
    type: "button",
    title: "Close Fullscreen",
    className: cs(styles.button, styles.closeButton),
    onClick: onFullscreenButtonClick
  }, /*#__PURE__*/React.createElement(Icon, {
    content: closeIconSVG,
    className: styles.closeIcon,
    title: "Close Fullscreen"
  }));
  var playPauseButton = /*#__PURE__*/React.createElement("button", {
    "data-testid": "start-button",
    className: cs(styles.button, styles.play, playPauseButtonClassName, (showControls || isEnded || !hasBeenPlayed) && styles.show),
    type: "button",
    onClick: onPlayPauseButtonClick,
    onFocus: onButtonFocus,
    onBlur: onButtonBlur,
    ref: startButtonRef,
    onMouseDown: e => e.preventDefault() // prevent focus from being added with mouse
    ,
    title: isPlaying ? 'Pause Video' : "Play Video".concat(!hasBeenPlayed && launchFullscreenOnStart ? ' In Fullscreen' : ''),
    "aria-label": isPlaying ? 'Pause Video' : "Play Video".concat(!hasBeenPlayed && launchFullscreenOnStart ? ' In Fullscreen' : '')
  }, isPlaying ? pauseButton : playButton);
  var captionsLi = /*#__PURE__*/React.createElement("li", {
    key: "captions-control-".concat(videoUID),
    className: cs(styles.control, styles.captionsControl)
  }, /*#__PURE__*/React.createElement("button", {
    className: cs(styles.button, styles.toggleCaptions),
    type: "button",
    onClick: onCaptionsToggleClick,
    onFocus: onButtonFocus,
    onBlur: onButtonBlur,
    onMouseDown: e => e.preventDefault() // prevent focus from being added with mouse
    ,
    title: isShowingCaptions ? 'Hide Captions' : 'Show Captions'
  }, isShowingCaptions ? captionsOnIcon : captionsOffIcon));
  var videoPoster = [startButtonImageProps && /*#__PURE__*/React.createElement(Image, _extends({
    key: "video-poster-image-".concat(videoUID)
  }, startButtonImageProps, {
    className: cs(startButtonImageProps.className, styles.startButtonImage)
  })), showDuration && /*#__PURE__*/React.createElement("span", {
    key: "video-duration-tag-".concat(videoUID),
    className: styles.duration,
    "data-testid": "posterDuration"
  }, /*#__PURE__*/React.createElement("span", {
    className: "lll-hidden-visually"
  }, "Duration"), prettyVideoDuration)];
  var controls = /*#__PURE__*/React.createElement("div", {
    "data-testid": "ctrl",
    className: cs(styles.controls, showControls && styles.show)
  }, {
    minimal: /*#__PURE__*/React.createElement("ul", {
      className: cs(styles.controlsList, styles.center)
    }, [supportsAudio && volumeLi, showDuration && timeTrackerLi, showCaptionsToggle && captionsLi, showFullscreenToggle && fullscreenLi]),
    inline: /*#__PURE__*/React.createElement("ul", {
      className: cs(styles.controlsList, styles.center)
    }, [playPauseLi, supportsAudio && volumeLi, progressLi, showDuration && timeTrackerLi, showCaptionsToggle && captionsLi, showFullscreenToggle && fullscreenLi]),
    stacked: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("ul", {
      className: cs(styles.controlsList, styles.center)
    }, progressLi), /*#__PURE__*/React.createElement("ul", {
      className: cs(styles.controlsList, styles.center)
    }, [isPartOfSeries && playPreviousLi, playPauseLi, isPartOfSeries && playNextLi, supportsAudio && volumeLi, showDuration && timeTrackerLi, showCaptionsToggle && captionsLi, showFullscreenToggle && fullscreenLi]))
  }[controlLayout]);
  return (
    /*#__PURE__*/
    /* eslint-disable-next-line */
    React.createElement("div", {
      className: cs(styles.overlay, styles.asPoster, isEnded && styles.overlayEnded),
      onClick: onOverlayClick,
      ref: overlayRef
    }, (!hasBeenPlayed || isEnded || controlLayout === 'minimal') && playPauseButton, showCloseFullscreen && /*#__PURE__*/React.createElement("div", {
      className: cs(styles.topControls, isFullscreen && showControls && styles.show)
    }, /*#__PURE__*/React.createElement("div", {
      className: cs(styles.center, styles.topControlsList)
    }, closeButton)), !hasBeenPlayed || isEnded ? videoPoster : controls)
  );
};
VideoPlayerControlOverlay.propTypes = {
  controlLayout: PropTypes.oneOf(['minimal', 'inline', 'stacked']).isRequired,
  currentTime: PropTypes.number,
  currentVolume: PropTypes.number,
  hasBeenPlayed: PropTypes.bool.isRequired,
  isEnded: PropTypes.bool.isRequired,
  isFullscreen: PropTypes.bool.isRequired,
  isMuted: PropTypes.bool.isRequired,
  isPartOfSeries: PropTypes.bool,
  isPlaying: PropTypes.bool.isRequired,
  isShowingCaptions: PropTypes.bool,
  launchFullscreenOnStart: PropTypes.bool.isRequired,
  nextInSeriesButtonRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  onButtonFocus: PropTypes.func.isRequired,
  onButtonBlur: PropTypes.func.isRequired,
  onCaptionsToggleClick: PropTypes.func.isRequired,
  onFullscreenButtonClick: PropTypes.func.isRequired,
  onMuteButtonClick: PropTypes.func.isRequired,
  onOverlayClick: PropTypes.func.isRequired,
  onPlayPauseButtonClick: PropTypes.func.isRequired,
  onProgressKeyDown: PropTypes.func.isRequired,
  onProgressRangeClick: PropTypes.func.isRequired,
  onVolumeBarHoverChange: PropTypes.func.isRequired,
  onVolumeInputChange: PropTypes.func.isRequired,
  onVolumeRangeClick: PropTypes.func.isRequired,
  overlayRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  playPauseButtonClassName: PropTypes.string,
  previousInSeriesButtonRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  showCaptionsToggle: PropTypes.bool,
  showControls: PropTypes.bool.isRequired,
  showCloseFullscreen: PropTypes.bool,
  showDuration: PropTypes.bool,
  showFullscreenToggle: PropTypes.bool,
  showVolumeBar: PropTypes.bool.isRequired,
  startButtonImageProps: PropTypes.shape({
    alt: PropTypes.string,
    className: PropTypes.string,
    src: PropTypes.string.isRequired
  }),
  startButtonRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  supportsAudio: PropTypes.bool,
  videoDuration: PropTypes.number,
  videoUID: PropTypes.string.isRequired,
  volumeBarRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  volumeControlRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired
};
VideoPlayerControlOverlay.defaultProps = {
  playPauseButtonClassName: null,
  currentTime: 0,
  currentVolume: 0,
  isPartOfSeries: false,
  isShowingCaptions: true,
  showCaptionsToggle: false,
  showCloseFullscreen: false,
  showDuration: true,
  showFullscreenToggle: true,
  startButtonImageProps: null,
  supportsAudio: true,
  videoDuration: 0
};
export default VideoPlayerControlOverlay;